// extracted by mini-css-extract-plugin
module.exports = {"bookmarks":"styles_bookmarks__1eKAU","showMoreButton":"styles_showMoreButton__3oSnQ"};